import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';
import { blockedTankSoftRule } from './stowageRules/blockedTankSoftRule';
import { cargoNegativeNominatedWeightHardRule } from './stowageRules/cargoNegativeNominatedWeightHardRule';
import { cargoNegativeStowedWeightHardRule } from './stowageRules/cargoNegativeStowedWeightHardRule';
import { fillRatioOver98PercentSoftRule } from './stowageRules/fillRatioOver98PercentSoftRule';
import { ibc15_11_3SoftRule } from './stowageRules/ibc15_11_3SoftRule';
import { ibc15_14SoftRule } from './stowageRules/ibc15_14SoftRule';
import { ibc16_6_3_or_4HardRule } from './stowageRules/ibc16_6_3_or_4HardRule';
import { illegalComminglingHardRule } from './stowageRules/illegalComminglingHardRule';
import { incompatibleHeatingMediumSoftRule } from './stowageRules/incompatibleHeatingMediumSoftRule';
import { incompatibleIbcShipTypeHardRule } from './stowageRules/incompatibleIbcShipTypeHardRule';
import { incompatibleIbcTankTypeHardRule } from './stowageRules/incompatibleIbcTankTypeHardRule';
import { incompatiblePressureVacuumSettingsHardRule } from './stowageRules/incompatiblePressureVacuumSettingsHardRule';
import { insufficientHeatingCapacitySoftRule } from './stowageRules/insufficientHeatingCapacitySoftRule';
import { maxAdjacentTemperatureHardRule } from './stowageRules/maxAdjacentTemperatureHardRule';
import { maxAdjacentTemperatureSoftRule } from './stowageRules/maxAdjacentTemperatureSoftRule';
import { oxygenSensitiveProductsSoftRule } from './stowageRules/oxygenSensitiveProductsSoftRule';
import { propyleneOxideHardRule } from './stowageRules/propyleneOxideHardRule';
import { propyleneOxideSoftRule } from './stowageRules/propyleneOxideSoftRule';
import { tankVolumeCapacityExceededForCargoIbcShipTypeOneHardRule } from './stowageRules/tankVolumeCapacityExceededForCargoIbcShipTypeOneHardRule';
import { tankVolumeCapacityExceededForCargoIbcShipTypeTwoHardRule } from './stowageRules/tankVolumeCapacityExceededForCargoIbcShipTypeTwoHardRule';
import { tankVolumeCapacityExceededHardRule } from './stowageRules/tankVolumeCapacityExceededHardRule';
import { tankWeightCapacityExceededHardRule } from './stowageRules/tankWeightCapacityExceededHardRule';
import { unstowedCargoOperationInDepartedCallHardRule } from './stowageRules/unstowedCargoOperationInDepartedCallHardRule';
import { usedCookingOilSoftRule } from './stowageRules/usedCookingOilSoftRule';
import { coatingCompatibilitySoftRule } from './stowageRules/coatingCompatibilitySoftRule';
import { coatingCompatibilityHardRule } from './stowageRules/coatingCompatibilityHardRule';
import { basfHmdSoftRule } from './stowageRules/basfHmdSoftRule';
import { uscgCompatibilityHardRule } from './stowageRules/uscgCompatibilityHardRule';
import { type2KCommodityHardRule } from './stowageRules/type2KCommodityHardRule';
import { tankMaxLitreWeightExceededSoftRule } from './stowageRules/tankMaxLitreWeightExceededSoftRule';
import { tankMaxLitreWeightExceededHardRule } from './stowageRules/tankMaxLitreWeightExceededHardRule';
import { manualCargoOperationInDepartedCallSoftRule } from './stowageRules/manualCargoOperationInDepartedCallSoftRule';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { cargoNegativeNominatedWeightInCallHardRule } from './stowageRules/cargoNegativeNominatedWeightInCallHardRule';
import { stowedWeightExceedsNominatedWeightHardRule } from './stowageRules/stowedWeightExceedsNominatedWeightHardRule';

export const commodityBookStowageRules: StowageRuleBM[] = [basfHmdSoftRule, oxygenSensitiveProductsSoftRule];

export const rotationStowageRules: StowageRuleBM[] = [
    blockedTankSoftRule,
    //ibc15_12_3HardRule, // Disabled as specifications are not yet fully aligned and no active vessels are compatible
];

export const cargoLoadingAndTransferOperationStowageRules: StowageRuleBM[] = [
    coatingCompatibilitySoftRule,
    coatingCompatibilityHardRule,
    fillRatioOver98PercentSoftRule,
    ibc15_11_3SoftRule,
    ibc15_14SoftRule,
    ibc16_6_3_or_4HardRule,
    illegalComminglingHardRule,
    incompatibleHeatingMediumSoftRule,
    incompatibleIbcShipTypeHardRule,
    incompatibleIbcTankTypeHardRule,
    incompatiblePressureVacuumSettingsHardRule,
    insufficientHeatingCapacitySoftRule,
    maxAdjacentTemperatureHardRule,
    maxAdjacentTemperatureSoftRule,
    propyleneOxideHardRule,
    propyleneOxideSoftRule,
    tankMaxLitreWeightExceededHardRule,
    tankMaxLitreWeightExceededSoftRule,
    tankVolumeCapacityExceededForCargoIbcShipTypeOneHardRule,
    tankVolumeCapacityExceededForCargoIbcShipTypeTwoHardRule,
    tankVolumeCapacityExceededHardRule,
    tankWeightCapacityExceededHardRule,
    type2KCommodityHardRule,
    usedCookingOilSoftRule,
    uscgCompatibilityHardRule,
];

export const cargoTransitOperationsStowageRules: StowageRuleBM[] = [uscgCompatibilityHardRule];

export const cargoOperationStowageRules: StowageRuleBM[] = [
    cargoNegativeNominatedWeightInCallHardRule,
    manualCargoOperationInDepartedCallSoftRule,
    unstowedCargoOperationInDepartedCallHardRule,
];

// Rules that require their own processing logic (e.g., voyage status based gating) and should not be subjected to generic pre-filters
export const cargoOperationSpecialCaseStowageRules: StowageRuleBM[] = [stowedWeightExceedsNominatedWeightHardRule];

export const cargoStowageRules: StowageRuleBM[] = [cargoNegativeNominatedWeightHardRule, cargoNegativeStowedWeightHardRule];

export const getStowageRules = (stowageRules: StowageRuleBM[], includeSoftRules: boolean, includeHardRules: boolean): StowageRuleBM[] => {
    return stowageRules.filter(
        (rule) =>
            (includeSoftRules && rule.consequence.type === StowageRuleConsequenceType.SoftRule) ||
            (includeHardRules && rule.consequence.type === StowageRuleConsequenceType.HardRule)
    );
};
